// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_reference_form_landing-layout {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  padding: 20px; }\n  .modal_reference_form_landing-layout .container-buttons-modal {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    width: 100%;\n    justify-content: flex-end; }\n    .modal_reference_form_landing-layout .container-buttons-modal > button {\n      width: fit-content; }\n", ""]);
// Exports
module.exports = exports;
